import createState from '@/store/model/state'

const state =  createState()
state.url = null
state.deliveryUrl = null

export default state